<ul class="file-list">
    <!-- Display Cert/Lic Files, add meta to show which file is linked -->
    <li class="file-list-item" *ngFor="let file of files">
        <div class="file-information">
            <span class="file-title">{{ file.fileName }}</span>
            <span class="file-type">{{ file.fileType }}</span> <!-- 10/05/2020 at 14:55 -->
            <span class="file-date">{{ file.lastModified | date: "mediumDate" }}</span> <!-- 10/05/2020 at 14:55 -->
        </div>
        <button class="file-download btn btn-default" (click)="download(file)"><fa-icon [icon]="faFileDownload"></fa-icon></button>
    </li>
</ul>